import { AngularFirestoreDocument } from "@angular/fire/firestore"
import { CompanyPricingVariable } from "@tr/models"
import { FirebaseDocumentBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

export class CompanySpecificPricingService extends FirebaseDocumentBase<CompanyPricingVariable> {
  constructor(private fb: FirebaseService, private company: string = "") {
    super(fb)
  }

  public getDocument(): AngularFirestoreDocument<CompanyPricingVariable> {
    return this.fb
    .collection("companies")
    .doc(this.company) // needs to find a way to pass company
    .collection("credits")
    .doc<CompanyPricingVariable>("credits")
  }
}
